import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { Tag } from 'src/services/tag/Tag';

import { TagNode } from 'src/services/tag-tree/TagNode';
import { getTopLevelTag } from 'src/utils/getTopLevelTag';
import { DetailedTag } from 'src/services/tag/DetailedTag';

@Component({
  selector: 'tag-node-icon',
  imports: [CommonModule, MatIconModule],
  standalone: true,
  templateUrl: './tag-node-icon.component.html',
  styleUrls: ['./tag-node-icon.component.scss'],
})
export class TagNodeIconComponent {
  @Input()
  tags: DetailedTag[] = [];

  @Input()
  node: TagNode | DetailedTag | null = null;

  getTopLevelTag(tag: any) {
    return getTopLevelTag(tag, this.tags);
  }
}
